(function () {
  loginWithFacebook.$inject = ["API_URL"];
  angular.module('calendarApp').directive('loginWithFacebook', loginWithFacebook);

  function loginWithFacebook(API_URL) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/login-with-facebook.html',
      scope: {
        updateFunction: '='
      },
      link: function link(scope, elem, attrs) {
        scope.showLogout = true;

        scope.loginWithFacebook = function () {
          FB.login(function (response) {
            if (response.status === 'connected') {
              // Logged into your app and Facebook.
              // Now get name and email
              FB.api('/me', {
                fields: ['first_name', 'last_name', 'email']
              }, function (response) {
                console.log(response);
                scope.updateFunction(response);
              });
            } else if (response.status === 'not_authorized') {// The person is logged into Facebook, but not your app.
            } else {// The person is not logged into Facebook, so we're not sure if
                // they are logged into this app or not.
              }
          }, {
            scope: 'public_profile,email'
          });
        };

        scope.logoutOfFacebook = function () {
          // Check that application urls are valid if you get weird errors
          FB.logout(function (response) {
            console.log(response);
          });
        };
      }
    };
  }
})();